import { api } from './api';

export interface WalletAdjustmentPayload {
  userUid: string;
  amount: number;
  direction: 'credit' | 'debit';
  reason: string;
}

export const createWalletAdjustment = (payload: WalletAdjustmentPayload) =>
  api.post('/admin/finance/wallet-adjustment', payload).then((r) => r.data);

export const getPendingAdjustments = () =>
  api.get('/admin/finance/wallet-adjustments/pending').then((r) => r.data);

export const decideAdjustment = (id: number, decision: 'approve' | 'reject', rejectionReason?: string) =>
  api.post(`/admin/finance/wallet-adjustment/${id}/decide`, { decision, rejectionReason }).then((r) => r.data);

export const refundRide = (payload: { rideId: number; amount?: number; reason: string }) =>
  api.post('/admin/finance/refund', payload).then((r) => r.data);

export const getUserCharges = (userUid: string) =>
  api.get('/admin/finance/charges', { params: { userUid } }).then((r) => r.data);

export const waiveCharge = (chargeId: number, reason: string) =>
  api.post(`/admin/finance/charge/${chargeId}/waive`, { reason }).then((r) => r.data);

export const getReconciliation = (from?: string, to?: string) => {
  const params: Record<string, string> = {};
  if (from) params.from = from;
  if (to) params.to = to;
  return api.get('/admin/finance/reconciliation', { params }).then((r) => r.data);
};
